import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { FocusPayDevice } from "src/app/shared/models/FocusPay/FocusPayDevice.model";
import { UserVenue } from "src/app/shared/models/user.model";

@Component({
	selector: "app-device-management",
	templateUrl: "./device-management.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class DeviceManagementComponent implements OnInit, OnDestroy {
	@Input() device: FocusPayDevice;
	@Output() deviceChange = new EventEmitter<FocusPayDevice>();

	@Output() onDeviceDeleteChange = new EventEmitter<FocusPayDevice>();

	@Output() onSaveChange = new EventEmitter<FocusPayDevice>();

	assignToDealer: boolean = false;
	assignToVenue: boolean = false;

	changesToSave: boolean = false;
	deviceImage: string;

	venueList: UserVenue[] = [];

	constructor(
		public app: AppService,
		public focuslink: FocuslinkService,
		public userService: UserService,
		public venueService: OOVenueService,
		public dealerService: DealerService
	) {}
	ngOnDestroy(): void {
		console.log("onDestroy");
		this.deviceImage = undefined;
	}

	ngOnInit(): void {
		console.log("onInit");
		this.deviceImage = undefined;
		this.venueList = this.userService.userVenues.value;
		this.deviceTypeSetImage();
	}

	async onSave() {
		if (this.device.newDevice) {
			try {
				const resp = await this.focuslink.focusPayDevicePost(this.device);
				this.device = new FocusPayDevice(resp);
				this.deviceChange.emit(this.device);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `New device saved successfully` });
				this.onSaveChange.emit(this.device);
				this.changesToSave = false;
				this.device = undefined;
				this.deviceChange.emit(undefined);
			} catch (error) {
				console.log(error);
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `${error.error.error}` });
			}
		} else {
			try {
				const resp = await this.focuslink.focusPayDevicePatch(this.device);
				this.device = new FocusPayDevice(resp);
				this.deviceChange.emit(this.device);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${this.device.key} updated successfully` });
				this.onSaveChange.emit(this.device);
				this.changesToSave = false;
				this.device = undefined;
				this.deviceChange.emit(undefined);
			} catch (error) {
				console.log(error);
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `${error.error.error}` });
			}
		}
	}

	async onDelete() {
		try {
			await this.focuslink.focusPayDeviceDelete(this.device.key);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${this.device.key} deleted` });
			this.onDeviceDeleteChange.emit(this.device);
			this.deviceChange.emit(null);
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `${error.error.error}` });
		}
	}

	deviceTypeSetImage() {
		console.log(this.device.type);
		switch (this.device.type) {
			case "e280":
				this.deviceImage = "https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-e280.png";
				break;
			case "e285p":
				this.deviceImage = "https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-e285.png";
				break;
			case "S1F2":
				this.deviceImage = "https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-s1f2.png";
				break;
			case "S1E":
				this.deviceImage = "https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-s1e.png";
				break;
			case "P400plus":
				this.deviceImage = "https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-p400.png";
		}
	}

	deviceVenueChange() {
		this.device.venueAssignment = `${this.device.venueKey} - ${
			this.userService.userVenues.value.find((i) => i.venueKey === this.device.venueKey).venueName
		}`;
	}

	dealerListChange() {
		this.venueList = this.userService.userVenues.value.filter((i) => i.dealerKey === this.device.dealerKey);
	}
}
